import { useEffect, useState } from "react";
import { StickyNote, Send, Trash2, User } from "lucide-react";
import api from "@/lib/api";

export default function CustomerNotes({ customerId }) {
  const [notes, setNotes] = useState([]);
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);

  const fetch = () => {
    api.get(`/customers/${customerId}/notes`).then((r) => setNotes(r.data)).catch(() => {});
  };

  useEffect(() => { fetch(); }, [customerId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setSending(true);
    try {
      await api.post(`/customers/${customerId}/notes`, { content: text });
      setText("");
      fetch();
    } catch { /* */ }
    setSending(false);
  };

  const handleDelete = async (noteId) => {
    if (!window.confirm("Remover esta nota?")) return;
    await api.delete(`/customers/${customerId}/notes/${noteId}`);
    fetch();
  };

  return (
    <div className="crm-card overflow-hidden" data-testid="customer-notes">
      <div className="px-6 py-4 flex items-center gap-2" style={{ borderBottom: "1px solid var(--crm-border)" }}>
        <StickyNote className="w-4 h-4" style={{ color: "var(--crm-accent)" }} />
        <h2 className="text-sm font-bold" style={{ color: "var(--crm-text)" }}>Notas ({notes.length})</h2>
      </div>

      {/* Add note */}
      <form onSubmit={handleSubmit} className="px-6 py-4 flex gap-3" style={{ borderBottom: "1px solid var(--crm-border)" }}>
        <input value={text} onChange={(e) => setText(e.target.value)} data-testid="note-input"
          className="crm-input flex-1" placeholder="Adicionar uma nota..." />
        <button type="submit" disabled={sending || !text.trim()} className="crm-btn-primary px-4" data-testid="note-submit">
          <Send className="w-4 h-4" />
        </button>
      </form>

      {/* Notes list */}
      {notes.length === 0 ? (
        <div className="px-6 py-8 text-center text-sm" style={{ color: "var(--crm-text-dim)" }}>Nenhuma nota adicionada</div>
      ) : (
        <div className="divide-y" style={{ borderColor: "var(--crm-border)" }}>
          {notes.map((note) => (
            <div key={note.id} className="px-6 py-4 group" data-testid={`note-${note.id}`}>
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <p className="text-sm leading-relaxed" style={{ color: "var(--crm-text)" }}>{note.content}</p>
                  <div className="flex items-center gap-2 mt-2">
                    <div className="w-5 h-5 rounded-full flex items-center justify-center text-[9px] font-bold"
                      style={{ background: "var(--crm-accent-subtle)", color: "var(--crm-accent)" }}>
                      {note.operator_name?.charAt(0)?.toUpperCase()}
                    </div>
                    <span className="text-xs font-medium" style={{ color: "var(--crm-text-muted)" }}>{note.operator_name}</span>
                    <span className="text-xs" style={{ color: "var(--crm-text-dim)" }}>· {new Date(note.created_at).toLocaleString("pt-BR")}</span>
                  </div>
                </div>
                <button onClick={() => handleDelete(note.id)}
                  className="p-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity hover:text-red-400"
                  style={{ color: "var(--crm-text-dim)" }}>
                  <Trash2 className="w-3.5 h-3.5" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
